/**
 * A simple pooling class.
 * Disables renderable on release
 */
export class PoolUtil {
    constructor(factory, startingPool) {
        this.members = new Set();
        this.factory = factory;
        this.pool = startingPool ?? [];
    }
    getNextElement() {
        const top = this.pool.shift();
        if (top) {
            top.renderable = true;
            return top;
        }
        const newElement = this.factory();
        this.members.add(newElement);
        return newElement;
    }
    releaseElement(element) {
        if (!this.members.has(element))
            return false;
        if (this.pool.includes(element))
            return;
        element.removeFromParent();
        element.renderable = false;
        this.pool.push(element);
        return true;
    }
}
//# sourceMappingURL=PoolUtil.js.map